import { useQuery } from "@tanstack/react-query";
import { CACHE_KEY_STATUSES } from "../../../utils/constants";
import statusService from "../../../services/ticketService/statusService";
import { StatusInterface } from "../../../models/TicketModule/Status";

const useStatuses = (page: number, pageSize: number) =>
  useQuery<StatusInterface[], Error>({
    queryKey: [
      CACHE_KEY_STATUSES,
      page > 0 ? page : null,
      pageSize > 0 ? pageSize : null,
    ],
    queryFn: () => statusService.GetAll(page, pageSize),
  });

export default useStatuses;
